import { render, staticRenderFns } from "./ws_tj.vue?vue&type=template&id=4eafe5d4"
import script from "./ws_tj.vue?vue&type=script&lang=js"
export * from "./ws_tj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports